import { useTenancy } from "@/contexts/TenancyContext";

export function useActiveTenancy() {
  const { activeTenancy } = useTenancy();
  // Replace with your actual tenancy context logic
  return activeTenancy;
}
